// DS: MO 4.1.7
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
import BoostIcon from '@wix/da-ds/pkg/Icons/16x16/BoostFilled';
import DeviationPromo from '../DeviationPromo';
import BoostRootModal from '../../../../ActionBar/buttons/BoostButton/modals/BoostRootModal';
import { BiData } from '@wix/da-bi/pkg/events';
import { ResourceType } from '../../../../types/resource';
const BoostPromo = ({ deviation })=>{
    const { t } = useTranslation();
    const [isShowingModal, setShowingModal] = useState(false);
    const openBoostModal = ()=>setShowingModal(true);
    const closeBoostModal = ()=>setShowingModal(false);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DeviationPromo, {
        deviation: deviation,
        onClick: openBoostModal,
        heading: t('sidebar.boostPromo.heading'),
        subheading: t('sidebar.boostPromo.description'),
        attributionSlot: deviation && t('sidebar.boostPromo.attribution'),
        ctaSlot: /*#__PURE__*/ React.createElement(SolidButton, {
            size: "medium",
            icon: BoostIcon,
            variant: "main",
            fillContainerWidth: true,
            onClick: openBoostModal,
            biData: BiData({
                evid: 320,
                sectionname: 'sidebar_boost_promo',
                itemid: deviation.deviationId,
                typeid: ResourceType.TIER,
                badge_type: 'boost',
                badge_typeid: 176
            })
        }, t('sidebar.boostPromo.sellCta'))
    }), isShowingModal && /*#__PURE__*/ React.createElement(BoostRootModal, {
        deviation: deviation,
        onRequestClose: closeBoostModal
    }));
};
BoostPromo.displayName = 'BoostPromo';
export default BoostPromo;

//# sourceMappingURL=BoostPromo.js.map